import { dispatchAction } from '@ardoq/rxbeach';
import { assistantEventTracked } from './actions';
import type { AssistantTrackingEvents } from './trackingEvents';

/**
 * Tracks an assistant event. The routine adds the current module and the
 * assistant context (see `withAssistantContext`); values passed in `metadata`
 * take precedence over them.
 */
export const trackAssistantEvent = (
  eventName: AssistantTrackingEvents,
  metadata: object = {}
): void => dispatchAction(assistantEventTracked({ eventName, metadata }));
